export const environment = {
  production: false,
  appVersion: "cmm",
  USERDATA_KEY: "SH5TtNCajQOEA27dQBAxPA==",
  api: "https://cmm-api.dev-x.team/api",
  authApi: 'https://ums-api.dev-x.team'
};
